import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { Button } from '../../components/aip';

/**
 * ダッシュボードページ（ログイン後のホーム画面）
 */
export const DashboardPage: React.FC = () => {
  const { user, logout } = useAuth();

  return (
    <>
      <h2 style={{ fontSize: '1.25rem', fontWeight: 500, marginBottom: '1rem' }}>
        ダッシュボード
      </h2>
      
      <div
        style={{
          padding: '1.5rem',
          backgroundColor: 'var(--color-solid-gray25)',
          borderRadius: '1rem',
          border: '1px solid var(--color-opacity-gray150)',
        }}
      >
        <p style={{ marginBottom: '1rem' }}>
          ようこそ、<strong>{user?.name || user?.email}</strong> さん
        </p>
        <p style={{ color: 'var(--text-secondary)', fontSize: '0.875rem', marginBottom: '1.5rem' }}>
          会社ID: {user?.companyId}
        </p>
        
        <Button buttonType="outline" size="sm" onClick={logout}>
          ログアウト
        </Button>
      </div>

      <div style={{ marginTop: '2rem' }}>
        <h3 style={{ fontSize: '1rem', fontWeight: 500, marginBottom: '1rem' }}>
          クイックアクセス
        </h3>
        <div style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap' }}>
          <Button
            as="a"
            href="/meeting/manage-new/ai-managers"
            buttonType="outline-subtle"
            size="sm"
            iconPosition="start"
            icon="smart_toy"
          >
            AIマネージャー管理
          </Button>
          <Button
            as="a"
            href="/meeting/manage-new/check-templates"
            buttonType="outline-subtle"
            size="sm"
            iconPosition="start"
            icon="checklist"
          >
            チェックテンプレート
          </Button>
        </div>
      </div>
    </>
  );
};

export default DashboardPage;




